// data.js
const delegateData = [
    {
      "name": "Malcolm Augustine",
      "img": "https://mgaleg.maryland.gov/2023RS/images/augustine01.jpg",
      "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/augustine01",
      "party": "D",
      "district": "47",
      "committee": "EEE",
      "votes": {
        "Transit Equity": "+",
        "Comprehensive Flood Management": "+",
        "Greenspace Equity": "+",
        "Offshore Wind": "+",
        "LMI Energy Efficiency": "+",
        "Community Solar": "+",
        "Clean Trucks Act": "+",
        "Clean Transportation and Energy": "+",
        "Maryland the Beautiful": "+",
        "Forest Conservation Act": "+"
      },
      "2023 Score": "100%",
      "Life time Score": "97%"
    },
    {
      "name": "Jack Bailey",
      "img": "https://mgaleg.maryland.gov/2023RS/images/bailey01.jpg",
      "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/bailey01",
      "party": "R",
      "district": "29",
      "committee": "BAT",
      "votes": {
        "Transit Equity": "-",
        "Comprehensive Flood Management": "+",
        "Greenspace Equity": "-",
        "Offshore Wind": "-",
        "LMI Energy Efficiency": "E",
        "Community Solar": "E",
        "Clean Trucks Act": "-",
        "Clean Transportation and Energy": "-",
        "Maryland the Beautiful": "+",
        "Forest Conservation Act": "+"
      },
      "2023 Score": "43%",
      "Life time Score": "47%"
    },
    {
      "name": "Pamela Beidle",
      "img": "https://mgaleg.maryland.gov/2023RS/images/beidle01.jpg",
      "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/beidle01",
      "party": "D",
      "district": "32",
      "committee": "FIN",
      "votes": {
        "Transit Equity": "+",
        "Comprehensive Flood Management": "+",
        "Greenspace Equity": "+",
        "Offshore Wind": "+",
        "LMI Energy Efficiency": "+",
        "Community Solar": "+",
        "Clean Trucks Act": "+",
        "Clean Transportation and Energy": "E",
        "Maryland the Beautiful": "+",
        "Forest Conservation Act": "+"
      },
      "2023 Score": "100%",
      "Life time Score": "92%"
    },
    {
      "name": "Joanne C. Benson",
      "img": "https://mgaleg.maryland.gov/2023RS/images/benson.jpg",
      "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/benson",
      "party": "D",
      "district": "24",
      "committee": "BAT",
      "votes": {
        "Transit Equity": "+",
        "Comprehensive Flood Management": "+",
        "Greenspace Equity": "+",
        "Offshore Wind": "+",
        "LMI Energy Efficiency": "+",
        "Community Solar": "+",
        "Clean Trucks Act": "+",
        "Clean Transportation and Energy": "+",
        "Maryland the Beautiful": "+",
        "Forest Conservation Act": "+"
      },
      "2023 Score": "100%",
      "Life time Score": "89%"
    },
    {
      "name": "Benjamin Brooks",
      "img": "https://mgaleg.maryland.gov/2023RS/images/brooks02.jpg",
      "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/brooks02",
      "party": "D",
      "district": "10",
      "committee": "EEE",
      "votes": {
        "Transit Equity": "+",
        "Comprehensive Flood Management": "+",
        "Greenspace Equity": "+",
        "Offshore Wind": "+",
        "LMI Energy Efficiency": "+",
        "Community Solar": "+",
        "Clean Trucks Act": "+",
        "Clean Transportation and Energy": "+",
        "Maryland the Beautiful": "+",
        "Forest Conservation Act": "+"
      },
      "2023 Score": "100%",
      "Life time Score": "97%"
    },
    {
      "name": "Mary Beth Carozza",
      "img": "https://mgaleg.maryland.gov/2023RS/images/carozza02.jpg",
      "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/carozza02",
      "party": "R",
      "district": "38",
      "committee": "EEE",
      "votes": {
        "Transit Equity": "-",
        "Comprehensive Flood Management": "-",
        "Greenspace Equity": "+",
        "Offshore Wind": "-",
        "LMI Energy Efficiency": "+",
        "Community Solar": "-",
        "Clean Trucks Act": "-",
        "Clean Transportation and Energy": "-",
        "Maryland the Beautiful": "+",
        "Forest Conservation Act": "+"
      },
      "2023 Score": "40%",
      "Life time Score": "47%"
    },
    {
      "name": "Jill P. Carter",
      "img": "https://mgaleg.maryland.gov/2023RS/images/carter01.jpg",
      "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/carter01",
      "party": "D",
      "district": "41",
      "committee": "JPR",
      "votes": {
        "Transit Equity": "+",
        "Comprehensive Flood Management": "+",
        "Greenspace Equity": "+",
        "Offshore Wind": "+",
        "LMI Energy Efficiency": "+",
        "Community Solar": "+",
        "Clean Trucks Act": "+",
        "Clean Transportation and Energy": "+",
        "Maryland the Beautiful": "+",
        "Forest Conservation Act": "+"
      },
      "2023 Score": "100%",
      "Life time Score": "88%"
    },
    {
      "name": "Paul Corderman",
      "img": "https://mgaleg.maryland.gov/2023RS/images/corderman02.jpg",
      "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/corderman02",
      "party": "R",
      "district": "2",
      "committee": "BAT",
      "votes": {
        "Transit Equity": "-",
        "Comprehensive Flood Management": "-",
        "Greenspace Equity": "-",
        "Offshore Wind": "-",
        "LMI Energy Efficiency": "E",
        "Community Solar": "-",
        "Clean Trucks Act": "-",
        "Clean Transportation and Energy": "-",
        "Maryland the Beautiful": "+",
        "Forest Conservation Act": "+"
      },
      "2023 Score": "20%",
      "Life time Score": "40%"
    },
    {
      "name": "Sarah Elfreth",
      "img": "https://mgaleg.maryland.gov/2023RS/images/elfreth01.jpg",
      "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/elfreth01",
      "party": "D",
      "district": "30",
      "committee": "BAT",
      "votes": {
        "Transit Equity": "+",
        "Comprehensive Flood Management": "+",
        "Greenspace Equity": "+",
        "Offshore Wind": "+",
        "LMI Energy Efficiency": "E",
        "Community Solar": "E",
        "Clean Trucks Act": "+",
        "Clean Transportation and Energy": "+",
        "Maryland the Beautiful": "+",
        "Forest Conservation Act": "+"
      },
      "2023 Score": "100%",
      "Life time Score": "100%"
    },
    {
        "name": "Arthur Ellis",
        "img": "https://mgaleg.maryland.gov/2023RS/images/ellis01.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/ellis01",
        "party": "D",
        "district": "28",
        "committee": "FIN",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Brian J. Feldman",
        "img": "https://mgaleg.maryland.gov/2023RS/images/feldman.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/feldman",
        "party": "D",
        "district": "15",
        "committee": "EEE",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "90%"
      },
      {
        "name": "Bill Ferguson",
        "img": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/ferguson",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/ferguson",
        "party": "D",
        "district": "46",
        "committee": "PRE",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "96%"
      },
      {
        "name": "William G. Folden",
        "img": "https://mgaleg.maryland.gov/2023RS/images/folden02.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/folden02",
        "party": "R",
        "district": "4",
        "committee": "JPR",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "70%",
        "Life time Score": "32%"
      },
      {
        "name": "Jason Gallion",
        "img": "https://mgaleg.maryland.gov/2023RS/images/gallion01.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/gallion01",
        "party": "R",
        "district": "35",
        "committee": "EEE",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "-",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "+",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "40%",
        "Life time Score": "46%"
      },
      {
        "name": "Dawn Gile",
        "img": "https://mgaleg.maryland.gov/2023RS/images/gile01.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/gile01",
        "party": "D",
        "district": "33",
        "committee": "FIN",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Melony Griffith",
        "img": "https://mgaleg.maryland.gov/2023RS/images/griffith01.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/griffith01",
        "party": "D",
        "district": "25",
        "committee": "FIN",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "94%"
      },
      {
        "name": "Guy Guzzone",
        "img": "https://mgaleg.maryland.gov/2023RS/images/guzzone.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/guzzone",
        "party": "D",
        "district": "13",
        "committee": "BAT",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "96%"
      },
      {
        "name": "Antonio Hayes",
        "img": "https://mgaleg.maryland.gov/2023RS/images/hayes02.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/hayes02",
        "party": "D",
        "district": "40",
        "committee": "FIN",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "E",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "98%"
      },
      {
        "name": "Stephen Hershey",
        "img": "https://mgaleg.maryland.gov/2023RS/images/hershey.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/hershey",
        "party": "R",
        "district": "36",
        "committee": "FIN",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "-",
          "Offshore Wind": "N",
          "LMI Energy Efficiency": "+",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "30%",
        "Life time Score": "35%"
      },
      {
        "name": "Katie Fry Hester",
        "img": "https://mgaleg.maryland.gov/2023RS/images/hester01.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/hester01",
        "party": "D",
        "district": "9",
        "committee": "EEE",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Shelly Hettleman",
        "img": "https://mgaleg.maryland.gov/2023RS/images/hettleman02.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/hettleman02",
        "party": "D",
        "district": "11",
        "committee": "BAT",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "98%"
      },
      {
        "name": "Michael A. Jackson",
        "img": "https://mgaleg.maryland.gov/2023RS/images/jackson03.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/jackson03",
        "party": "D",
        "district": "27",
        "committee": "BAT",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "96%"
      },
      {
        "name": "Mary-Dulany James",
        "img": "https://mgaleg.maryland.gov/2023RS/images/james01.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/james01",
        "party": "D",
        "district": "34",
        "committee": "JPR",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "80%"
      },
      {
        "name": "J.B. Jennings",
        "img": "https://mgaleg.maryland.gov/2023RS/images/jennings.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/jennings",
        "party": "R",
        "district": "7",
        "committee": "BAT",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "-",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "+",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "E",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "44%",
        "Life time Score": "30%"
      },
      {
        "name": "Cheryl C. Kagan",
        "img": "https://mgaleg.maryland.gov/2023RS/images/kagan01.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/kagan01",
        "party": "D",
        "district": "17",
        "committee": "EEE",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "92%"
      },
      {
        "name": "Ariana B. Kelly",
        "img": "https://mgaleg.maryland.gov/2023RS/images/kelly03.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/kelly03",
        "party": "D",
        "district": "16",
        "committee": "JPR",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "99%"
      },
      {
        "name": "Nancy J. King",
        "img": "https://mgaleg.maryland.gov/2023RS/images/king.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/king",
        "party": "D",
        "district": "39",
        "committee": "BAT",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "E",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "90%"
      },
      {
        "name": "Katherine Klausmeier",
        "img": "https://mgaleg.maryland.gov/2023RS/images/klausmeier.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/klausmeier",
        "party": "D",
        "district": "8",
        "committee": "FIN",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "71%"
      },
      {
        "name": "Ben Kramer",
        "img": "https://mgaleg.maryland.gov/2023RS/images/kramer02.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/kramer02",
        "party": "D",
        "district": "19",
        "committee": "FIN",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "94%"
      },
      {
        "name": "Clarence K. Lam",
        "img": "https://mgaleg.maryland.gov/2023RS/images/lam02.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/lam02",
        "party": "D",
        "district": "12",
        "committee": "FIN",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Karen Lewis Young",
        "img": "https://mgaleg.maryland.gov/2023RS/images/young04.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/young04",
        "party": "D",
        "district": "3",
        "committee": "EEE",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "98%"
      },
      {
        "name": "Johnny Mautz",
        "img": "https://mgaleg.maryland.gov/2023RS/images/mautz02.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/mautz02",
        "party": "R",
        "district": "37",
        "committee": "FIN",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "-",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "+",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "30%",
        "Life time Score": "21%"
      },
      {
        "name": "Cory McCray",
        "img": "https://mgaleg.maryland.gov/2023RS/images/mccray02.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/mccray02",
        "party": "D",
        "district": "45",
        "committee": "BAT",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "E",
          "Greenspace Equity": "-",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "78%",
        "Life time Score": "94%"
      },
      {
        "name": "Mike McKay",
        "img": "https://mgaleg.maryland.gov/2023RS/images/mckay02.jpg",
        "contact": "https://mgaleg.maryland.gov/2023RS/images/mccray02.jpg",
        "party": "R",
        "district": "1",
        "committee": "JPR",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "70%",
        "Life time Score": "31%"
      },
      {
        "name": "C. Anthony Muse",
        "img": "https://mgaleg.maryland.gov/2023RS/images/muse01.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/muse01",
        "party": "D",
        "district": "26",
        "committee": "JPR",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "E",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "E",
          "Community Solar": "E",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "80%"
      },
      {
        "name": "Justin Ready",
        "img": "https://mgaleg.maryland.gov/2023RS/images/ready01.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/ready01",
        "party": "R",
        "district": "5",
        "committee": "FIN",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "-",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "+",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "30%",
        "Life time Score": "36%"
      },
      {
        "name": "Jim Rosapepe",
        "img": "https://mgaleg.maryland.gov/2023RS/images/rosapepe.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/rosapepe",
        "party": "D",
        "district": "21",
        "committee": "BAT",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "E",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "98%"
      },
      {
        "name": "Johnny Ray Salling",
        "img": "https://mgaleg.maryland.gov/2023RS/images/salling01.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/salling01",
        "party": "R",
        "district": "6",
        "committee": "BAT",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "-",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "50%",
        "Life time Score": "40%"
      },
      {
        "name": "Bryan Simonaire",
        "img": "https://mgaleg.maryland.gov/2023RS/images/simonaire.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/simonaire",
        "party": "R",
        "district": "31",
        "committee": "EEE",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "-",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "+",
          "Community Solar": "-",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "60%",
        "Life time Score": "49%"
      },
      {
        "name": "William Smith",
        "img": "https://mgaleg.maryland.gov/2023RS/images/smith02.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/smith02",
        "party": "D",
        "district": "20",
        "committee": "JPR",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "98%"
      },
      {
        "name": "Charles E. Sydnor",
        "img": "https://mgaleg.maryland.gov/2023RS/images/sydnor02.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/sydnor02",
        "party": "D",
        "district": "44",
        "committee": "JPR",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "98%"
      },
      {
        "name": "Jeff Waldstreicher",
        "img": "https://mgaleg.maryland.gov/2023RS/images/waldstreicher1.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/waldstreicher1",
        "party": "D",
        "district": "18",
        "committee": "JPR",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Alonzo T. Washington",
        "img": "https://mgaleg.maryland.gov/2023RS/images/washington02.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/washington02",
        "party": "D",
        "district": "22",
        "committee": "JPR",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "E",
          "Community Solar": "E",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Mary Washington",
        "img": "https://mgaleg.maryland.gov/2023RS/images/washington01.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/washington01",
        "party": "D",
        "district": "43",
        "committee": "EEE",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Ron Watson",
        "img": "https://mgaleg.maryland.gov/2023RS/images/watson04.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/watson04",
        "party": "D",
        "district": "",
        "committee": "EEE",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Christopher West",
        "img": "https://mgaleg.maryland.gov/2023RS/images/west02.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/west02",
        "party": "R",
        "district": "42",
        "committee": "JPR",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "-",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "-",
          "Community Solar": "+",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "50%",
        "Life time Score": "79%"
      },
      {
        "name": "Craig J. Zucker",
        "img": "https://mgaleg.maryland.gov/2023RS/images/zucker01.jpg",
        "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/zucker01",
        "party": "D",
        "district": "14",
        "committee": "BAT",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      }
  ]
  
  
export default delegateData;
